import { FILTER_NAMES } from '../../../../../components/filters/hooks/filter-names.constants';
import { REPORT_NAMES } from '../../../../../components/reports/constants/report-names.constants';

export interface CompactViewLevelValue {
  value: any;
  label: string;
}
export interface CompactViewLevel {
  reportId: string;
  filterId: string;
  levelFilterId: string;
  drilldownFilterId?: string;
  valueFieldName: string;
  labelFieldName: string;
  nextLevel?: CompactViewLevelValue;

  className?: string;
  title: string;
  actionButtonVariant?: string;
}

export const COMPACT_VIEW_LEVELS: CompactViewLevel[] = [
  // {
  //     reportId:REPORT_NAMES.COMPACT_VIEW,
  //     filterId:'',
  //     levelFilterId:FILTER_NAMES.PRODUCTHIER_DRILLDOWN,
  //     drilldownFilterId:undefined,
  //     valueFieldName: "IRIS_CATEGORY_ID",
  //     labelFieldName: "IRIS_CATEGORY",
  //     nextLevel:{value:FILTER_NAMES.CATEGORY, label:"Category"},
  //     className:'_1',
  //     title:'Root'
  // },
  {
    reportId: REPORT_NAMES.COMPACT_VIEW,
    filterId: FILTER_NAMES.COMPACT_VIEW_CATEGORY,
    levelFilterId: FILTER_NAMES.PRODUCTHIER_DRILLDOWN,
    drilldownFilterId: FILTER_NAMES.CATEGORY_DRILLDOWN,
    valueFieldName: 'IRIS_CATEGORY_ID',
    labelFieldName: 'IRIS_CATEGORY',
    nextLevel: { value: FILTER_NAMES.CATEGORY, label: 'Category' },
    className: '_1',
    title: 'Category',
    actionButtonVariant: 'btn-sm btn-primary',
  },
  {
    reportId: REPORT_NAMES.COMPACT_VIEW,
    filterId: FILTER_NAMES.COMPACT_VIEW_BRAND,
    levelFilterId: FILTER_NAMES.PRODUCTHIER_DRILLDOWN,
    drilldownFilterId: FILTER_NAMES.BRAND_DRILLDOWN,
    valueFieldName: 'IRIS_BRAND_ID',
    labelFieldName: 'IRIS_BRAND',
    nextLevel: { value: FILTER_NAMES.BRAND, label: 'Brand' },
    className: '_1',
    title: 'Brand',
    actionButtonVariant: 'btn-sm btn-primary',
  },
  {
    reportId: REPORT_NAMES.COMPACT_VIEW,
    filterId: FILTER_NAMES.COMPACT_VIEW_SUBBRAND,
    levelFilterId: FILTER_NAMES.PRODUCTHIER_DRILLDOWN,
    drilldownFilterId: FILTER_NAMES.SUBBRAND_DRILLDOWN,
    valueFieldName: 'IRIS_SUB_BRAND_ID',
    labelFieldName: 'IRIS_SUB_BRAND',
    nextLevel: { value: FILTER_NAMES.SUBBRAND, label: 'Sub Brand' },
    className: '_2',
    title: 'Sub Brand',
    actionButtonVariant: 'btn-sm btn-outline-primary',
  },
  {
    reportId: REPORT_NAMES.COMPACT_VIEW,
    filterId: FILTER_NAMES.COMPACT_VIEW_SIZEGROUP,
    levelFilterId: FILTER_NAMES.PRODUCTHIER_DRILLDOWN,
    drilldownFilterId: FILTER_NAMES.SIZEGROUP_DRILLDOWN,
    valueFieldName: 'IRIS_SIZE_GROUP_ID',
    labelFieldName: 'IRIS_SIZE_GROUP',
    nextLevel: { value: FILTER_NAMES.SIZEGROUP, label: 'Size Group' },
    className: '_3',
    title: 'Size Group',
    actionButtonVariant: 'btn-sm btn-outline-primary',
  },
  {
    reportId: REPORT_NAMES.COMPACT_VIEW,
    filterId: FILTER_NAMES.COMPACT_VIEW_PPG,
    levelFilterId: FILTER_NAMES.PRODUCTHIER_DRILLDOWN,
    drilldownFilterId: FILTER_NAMES.PPG_DRILLDOWN,
    valueFieldName: 'IRIS_PPG_ID',
    labelFieldName: 'IRIS_PPG',
    nextLevel: { value: FILTER_NAMES.PPG, label: 'PPG' },
    className: '_4 inputcheckbox',
    title: 'PPG',
    actionButtonVariant: 'btn-sm btn-outline-primary',
  },
];

export const COMPACT_VIEW_LEVELS_BY_ID: Record<string, CompactViewLevel> = {
  [FILTER_NAMES.COMPACT_VIEW_CATEGORY]: COMPACT_VIEW_LEVELS[0],
  [FILTER_NAMES.COMPACT_VIEW_BRAND]: COMPACT_VIEW_LEVELS[1],
  [FILTER_NAMES.COMPACT_VIEW_SUBBRAND]: COMPACT_VIEW_LEVELS[2],
  [FILTER_NAMES.COMPACT_VIEW_SIZEGROUP]: COMPACT_VIEW_LEVELS[3],
  [FILTER_NAMES.COMPACT_VIEW_PPG]: COMPACT_VIEW_LEVELS[4],
};
